import React,{useEffect,useState} from 'react';
import {HorizontalBar,Bar} from 'react-chartjs-2';
import {Card,CardContent,Box, Typography} from "@material-ui/core";

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  contenedorCard:{
    //paddingRight:'3rem'
    height:12+'rem',marginRight:".3rem"
  },
  card:{
    boxShadow:'0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 2%)',
    //color:'#4a4a4a',
  },
  tituloGraf:{
    paddingTop:'0rem',
    textAlign:'center'
  },
  nested: {
    paddingLeft: theme.spacing(2),
  },
}));

export default function Graficas({valor}){
  const classes = useStyles();
  const color1= '#19A11E';  //ff1744  
  const color2= '#FBBE06';
  const auxColor=process.env.REACT_APP_Fondo_Color
  const [data,setData]= useState([]);
  const [datEdad,setDatEdad]= useState([]);
  const [bandera,setBandera]= useState(false);

  useEffect(()=>{    
    
    let aux={totH:0, GenX:0, totM:0, totX:0,  Tot25:0, Tot35:0, Tot45:0,
      Tot55:0, Tot65:0, Tot70:0,  }
      valor.forEach(element => {
      if (element!=="") {
    
      aux={ totH: aux.totH + parseInt( element.TotH),
        totM: aux.totM + parseInt(element.TotM),
        totX:aux.totX +  parseInt(element.TotX),    
        Tot25:aux.Tot25 +  parseInt(element.Tot25),    
        Tot35:aux.Tot35 +  parseInt(element.Tot35),   
        Tot45:aux.Tot45 +  parseInt(element.Tot45),  
        Tot55:aux.Tot55 +  parseInt(element.Tot55),  
        Tot65:aux.Tot65 +  parseInt(element.Tot65),   
        Tot70:aux.Tot70 +  parseInt(element.Tot70),    
      }
    }
    });  
    const{ 
      HTot, MTot, XTot,
      Tot25, Tot35, Tot45,
      Tot55, Tot65, Tot70,    
     }=aux
    setData({Hombre:aux.totH, Mujer:aux.totM,Binario:aux.totX})
    setDatEdad({Tot25:Tot25, Tot35:Tot35, Tot45:Tot45,
      Tot55:Tot55, Tot65:Tot65, Tot70:Tot70,})

    setBandera(true)
  },[valor])

  const dataGenero = {
    labels: ['Género'],
    datasets: [
    { type: 'bar', label:[ 'No Binario' ],
        data:[data.Binario],//[10, 20, 30, 40],
        backgroundColor:  [ "#4BAC7D50"]//'rgba(255, 99, 132, 0.2)',         
      },              
      { label:'Hombre',
        type: 'bar',
        data: [data.Hombre], //[50, 40, 30, 50],
        backgroundColor:'#4BAC7D',
        borderColor: '#4BAC7D',
        //fill: false,
        tension: 0.4           
      },
      { label:'Mujer',
        type: 'bar',
        data: [data.Mujer], //[50, 40, 30, 50],
        backgroundColor:'#C52363',
        borderColor: '#C52363',
        //fill: false,
        tension: 0.4   
        
      },   
    ],
  }; 

  const dataEdad = {
    labels: ['Edad'],
    datasets: [
    { type: 'bar', label:[ '18 a 25' ],
        data:[datEdad.Tot25],//[10, 20, 30, 40],
        backgroundColor:  [ "#4BAC7D50"]//'rgba(255, 99, 132, 0.2)',         
      },              
      { label:'26 a 35',
        type: 'bar',
        data: [datEdad.Tot35], //[50, 40, 30, 50],
        backgroundColor:'#4BAC7D',
        borderColor: '#4BAC7D',
        //fill: false,
        tension: 0.4           
      },
      { label:'36 a 45',
        type: 'bar',
        data: [datEdad.Tot45], //[50, 40, 30, 50],
        backgroundColor:'#C52363',
        borderColor: '#C52363',
        //fill: false,
        tension: 0.4   
        
      },   
      { label:'46 a 55',
        type: 'bar',
        data: [datEdad.Tot55], //[50, 40, 30, 50],
        backgroundColor:'#B406D8',
        borderColor: '#B406D8',
        //fill: false,
        tension: 0.4   
        
      },   
      { label:'56 a 65',
        type: 'bar',
        data: [datEdad.Tot65], //[50, 40, 30, 50],
        backgroundColor:'#FFA318',
        borderColor: '#FFA318',
        //fill: false,
        tension: 0.4   
        
      },   
      { label:'Mayor de 65',
        type: 'bar',
        data: [datEdad.Tot75], //[50, 40, 30, 50],
        backgroundColor:'#7C594C',
        borderColor: '#7C594C',
        //fill: false,
        tension: 0.4   
        
      },   
    ],
  }; 

  const dataEdadHoz = {
    labels: ["Menor o igual a 25","26 a 35", "36 a 45", "46 a 55", "56 a 65",'Mayor de 65'],
    datasets: [{
      data: [datEdad.Tot25, datEdad.Tot35, datEdad.Tot45, datEdad.Tot55, datEdad.Tot65, datEdad.Tot70],
      backgroundColor: ["#4BAC7D50","#4BAC7D","#C52363", "#B406D8", "#FFA318", "#7C594C" ],
      hoverBackgroundColor: [
        color1,
        color2
      ]
    }]
  }; 

  const options = {
  
  //  indexAxis:'y',
    tooltips: {
      enabled: true,
    },
   /*  layout: {
      padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
      }
    }, */
    title:{
      fontStyle: 'bold',
    },
    scales: {
      x: {
          display: true,
          title: {
          display: true
          }
      },
      y: {
          display: true,
          title: {
          display: false,
       
          },
       
      },
      }
   /*  scales: {
      x: {
        stacked: true,
        ticks: {
          beginAtZero: true,
        },
      },
      y: {
        stacked: true,
        labe :{
          fontSize:6,
        },
      }
    
    }, */
  } 

  const options2 = {  
    plugins: {
      legend: {
        display: false
      }
    },
    tooltips: {
      enabled: true,
    },
    indexAxis:'y',
    title:{
      fontStyle: 'bold',
    },
    scales: {
      x: {
        display: true,
        title: {
          display: true
        }
      },
      y: {
        display: true,
        title: {
          display: false,      
        },        
      },
    }
  } 
  
  function  llenadoTabla2(datos,options)
  {
    return(
    <Card className={classes.card} style={{paddingRight:.8+'rem',paddingLeft:.8+'rem' 
      ,paddingBottom:.5+'rem',height:14+'rem',width:27+'rem'}} >              
      <Bar
        id="graficaMuni"
        data={datos}
        width={450} height={270} 
        options={options}
      />   
    </Card>
    );
  }

  return (
  <Box display="flex" flexDirection="row" justifyContent={'center'} mb={1} style={{marginTop:1+'rem'}} >           
    <Box display="flex"className={classes.contenedorCard}  >
      {bandera ?llenadoTabla2(dataGenero,options):null}
    </Box>      
    <Box display="flex"className={classes.contenedorCard}  >
      {bandera ?llenadoTabla2(dataEdadHoz,options2):null}
    </Box>          
  </Box>
  );
}